
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { SwarmDataMixin, getSwarmDataKeyForRequest } from "../../../mixins/swarmDataMixin";
import { getSwarmSubscriptionRequestGameMarketsList } from "../../../helpers/terminalRequests/gameMarketsList";
import { GameMarketsListUpdateReceived, ResetGameMarketsList } from "../../../actions/gameMarketsActions";
import { handleGameMarketsListSubscriptionData } from "../../../helpers/gameMarketsHelpers/index";
import { createSelector } from "reselect";
import Helpers from "../../../helpers/helperFunctions";
import { UIMixin } from "../../../mixins/uiMixin";
import { GetArrayForAllLayers } from "../../../helpers/util/swarmTreeDestructuring";

class GameWrapper extends Component {
    constructor (props) {
        super(props);
        this.state = {
            someLoading: false
        };
        this.timerId = null;
        this.scroll = this.scroll.bind(this);
    }

    scroll (scrollSize) {
        return () => {
            let iterator = (scrollSize > 0 ? 0.1 : -0.1);
            this.delta = this.delta || iterator;
            this.delta += iterator;
            this.scrollMarkets.scrollTop += (scrollSize + this.delta);
        };
    }

    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
    componentDidMount () {
        this.timerId = setTimeout(() => {
            this.setState({ someLoading: true });
        }, 5000);
    }
    componentWillUnmount () {
        this.timerId && clearTimeout(this.timerId);
        this.props.dispatch(ResetGameMarketsList());
    }
}

GameWrapper.propTypes = {
    routeParams: PropTypes.object,
    params: PropTypes.object,
    data: PropTypes.object,
    selectorKey: PropTypes.string,
    virtualGameId: PropTypes.number,
    providerId: PropTypes.number
};

const mapStateToProps = (_, ownParams) => {
    let key = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestGameMarketsList(ownParams.virtualGameId || (ownParams.routeParams && ownParams.routeParams.gameId)));
    return createSelector(
        [
            state => state.swarmData.data[key] && JSON.stringify((() => {
                if (Object.keys(state.swarmData.data[key].sport).length !== 0) {
                    let data = {},
                        Sport = Helpers.firstElement(state.swarmData.data[key].sport),
                        Region = Helpers.firstElement(Sport.region),
                        Competition = Helpers.firstElement(Region.competition),
                        Game = Helpers.firstElement(Competition.game);
                    data.sportName = Sport.name;
                    data.sportAlias = Sport.alias;
                    data.regionName = Region.name;
                    data.competitionName = Competition.name;
                    data.team1_name = Game.team1_name;
                    data.team2_name = Game.team2_name;
                    data.gameType = Game.type;
                    data.showType = Game.show_type;
                    data.sportcast_id = Game.sportcast_id;

                    return data;
                }
            })()),
            state => state.swarmData.loaded[key],
            state => state.uiState.multiComponent.array,
            state => state.uiState.multiComponent.cursor
        ],
        (data, loading, gameArray, cursor) => {
            return {
                data: data && JSON.parse(data),
                loading,
                gameArray,
                cursor,
                selectorKey: key
            };
        });
};

export default connect(mapStateToProps)(SwarmDataMixin({
    Component: UIMixin({ Component: GameWrapper }),
    ComponentWillMount: function () {
        let { routeParams, virtualGameId } = this.props;
        this.swarmSubscriptionRequest = getSwarmSubscriptionRequestGameMarketsList(virtualGameId || (routeParams && routeParams.gameId));
        this.swarmDataKey = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestGameMarketsList(virtualGameId || (routeParams && routeParams.gameId)));
        this.meta = {
            simplify: true,
            preventOriginalAction: true,
            finalize: (loaded) => {
                return {
                    additionalActions: [GameMarketsListUpdateReceived.bind(null, handleGameMarketsListSubscriptionData(loaded, virtualGameId || routeParams.gameId))]
                };
            }
        };
    }
}));